export const RETURN_CODES_ZIP_FILE_NAME = 'return-codes';
export const RETURN_POSTERS_ZIP_FILE_NAME = 'return-posters';
